import React from 'react';
import CommentAuthor from 'modules/comment/comment.author';
import { Popup } from './popup';
import { useSelector } from 'react-redux';

interface PostInfoProps {
  singlePost: boolean;
  post: any;
  preview: boolean;
  user: any;
  avatarText: any;
  edit?: () => void;
  delete?: () => void;
}

export const PostInfo = ({
  post,
  preview,
  user,
  avatarText,
  edit,
  singlePost,
  delete: deleteFn,
}: PostInfoProps): JSX.Element | null => {
  if (!user) return null;

  const authUser = useSelector((state: any) => state?.auth?.user);
  const postAuthorId = user?._id || post?.user;
  if (!postAuthorId) return null;
  const isOwner = authUser && postAuthorId === authUser._id;

  const popup = (
    <Popup
      singlePost={singlePost}
      post={post}
      edit={edit}
      userId={postAuthorId}
      deleteFn={deleteFn}
      isOwner={isOwner}
    />
  );

  return (
    <CommentAuthor
      avatarText={avatarText}
      comment={post}
      user={user}
      popup={!preview && popup}
      preview={preview}
    />
  );
};

export default PostInfo;
